import { useAuth } from '@polvo-labs/react-auth'
import React from 'react'
import { matchPath, Redirect, Route, Switch } from 'react-router'
import Footer from '../../components/Footer'
import Header from '../../components/Header/Common'
import routes from '../../config/routes'
import { theme, ThemeProvider } from '../../config/theme'
import { Container } from './styles'

const CommonArea = () => {
  const { authenticated, user } = useAuth()
  const publicUrls = [
    routes.index.path,
    routes.contact.path,
    routes.faq.path,
    routes.login.path,
    routes.activation_landing.path,
    routes.activation_welcome.path,
  ]
  const existInPublicRoutes = publicUrls.filter((url) => {
    const match = matchPath(window.location.pathname, url)
    return url === match?.path
  })

  const isPublicUrl = existInPublicRoutes.length > 1 || (existInPublicRoutes.length === 1 && existInPublicRoutes[0] === routes.index.path && !authenticated)

  if (!authenticated && !isPublicUrl) {
    return (
      <Redirect
        to={routes.login.path}
      />
    )
  }
  const matchActivatePage = matchPath(window.location.pathname, routes.account_activation)
  if (authenticated && user && !user.verified && window.location.pathname !== matchActivatePage?.path && window.location.pathname === routes.realty.create.path) {

    return (
      <Redirect
        to={routes.account_activation.path}
      />
    )
  }

  return (
    <ThemeProvider
      theme={theme}
    >
      <Header />

      <Container>
        <Switch>
          <Route
            path={routes.settings.account.path}
            component={routes.settings.account.component}
          />

          <Route
            path={routes.settings.menu.path}
            component={routes.settings.menu.component}
          />

          <Route
            path={routes.settings.security.session.path}
            component={routes.settings.security.session.component}
          />

          <Route
            path={routes.settings.security.email.path}
            component={routes.settings.security.email.component}
          />

          <Route
            path={routes.settings.security.password.path}
            component={routes.settings.security.password.component}
          />

          <Route
            path={routes.settings.security.index.path}
            component={routes.settings.security.index.component}
          />

          <Route
            path={routes.settings.index.path}
            component={routes.settings.index.component}
          />

          <Route
            path={routes.realty.edit.path}
            component={routes.realty.edit.component}
          />

          <Route
            path={routes.realty.create.path}
            component={routes.realty.create.component}
          />

          <Route
            path={routes.realty.index.path}
            component={routes.realty.index.component}
          />

          <Route
            path={routes.contact.path}
            component={routes.contact.component}
          />
          <Route
            path={routes.privacy.path}
            component={routes.privacy.component}
          />
          <Route
            path={routes.terms.path}
            component={routes.terms.component}
          />

          <Route
            path={routes.account_activation.path}
            component={routes.account_activation.component}
          />
          <Route
            path={routes.activation_landing.path}
            component={routes.activation_landing.component}
          />
          <Route
            path={routes.activation_welcome.path}
            component={routes.activation_welcome.component}
          />

          <Route
            path={routes.faq.path}
            component={routes.faq.component}
          />

          <Route
            path={routes.index.path}
            component={routes.index.component}
          />
        </Switch>

        <Route
          path={routes.login.path}
          component={routes.login.component}
        />

        <Route
          path={routes.forgot.path}
          component={routes.forgot.component}
        />

        <Route
          path={routes.reset.path}
          component={routes.reset.component}
        />

      </Container>

      <Footer />
    </ThemeProvider>
  )
}

export default CommonArea
